import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";

const features = [
  {
    no: "01",
    title: "材料成组，而不是单张截图",
    desc: "一张截图只是线索，截图加合同加时间线才是稿件。编辑要的是能把一件事说完整的证据链。",
  },
  {
    no: "02",
    title: "有真实的人，也有真实的代价",
    desc: "稿件里出现具体当事人和他的处境，读者才会代入。抽象的「很多人都受影响」很难打动人。",
  },
  {
    no: "03",
    title: "冲突清晰，且双方都有声音",
    desc: "谁和谁、为了什么僵持不下，被指一方也留出回应位置，稿件才经得起推敲。",
  },
  {
    no: "04",
    title: "标题把最有信息量的细节提前",
    desc: "用数字、时间与反差替代程度副词，让读者一眼就看见事情的关键矛盾。",
  },
];

export default function ViralFeatures() {
  return (
    <section className="w-full bg-background-100 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto grid w-full grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center">
        <div className="lg:col-span-5">
          <div className="relative overflow-hidden rounded-lg border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20editorial%20desk%20scene%20with%20stacks%20of%20printed%20reports%20annotated%20in%20red%20ink%2C%20a%20magnifier%20and%20a%20warm%20desk%20lamp%2C%20soft%20evening%20light%2C%20muted%20cream%20and%20terracotta%20tones%2C%20clean%20magazine%20composition%2C%20high%20detail&width=1100&height=900&seq=baodian-viral-features&orientation=landscape"
              alt="带批注的稿件与放大镜，示意爆款稿件特征拆解"
              title="爆款稿件特征 - 编辑批注与材料核对"
              className="h-[320px] w-full object-cover object-top md:h-[440px]"
            />
            <div className="absolute bottom-4 left-4 right-4 rounded-md bg-background-50/95 p-4 backdrop-blur">
              <p className="text-xs font-medium text-primary-600">编辑视角</p>
              <p className="mt-1.5 text-sm leading-snug text-foreground-700">
                「好稿件不是文笔好，而是不用追问就能看懂事情的全貌。」
              </p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <SectionHeading
            eyebrow="爆款稿件特征"
            title="被采用的稿件，都赢在这四个细节上"
            desc="翻看被采用的投稿会发现，它们未必文采斐然，但都在同一件事上做对了——让人相信，也让人看得下去。"
          />

          <div className="mt-10 space-y-6">
            {features.map((item, index) => (
              <Reveal key={item.no} delay={index * 90}>
                <div className="flex gap-5 border-b border-background-200 pb-6 last:border-none">
                  <span className="font-heading text-2xl font-bold text-primary-500 md:text-3xl">
                    {item.no}
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Link
            to="/guide"
            className="mt-8 inline-flex items-center gap-2 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 cursor-pointer"
          >
            阅读完整投稿指南
            <i className="ri-arrow-right-line text-base leading-none"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}